import { Button, notification, Select } from 'antd';
import { uniq } from 'lodash';
import React, { useEffect, useState } from 'react';
import { validateEmail } from 'utils/validate';
import FieldRegister from 'views/common/FieldRegister';
import TextField from 'views/common/TextField';
import API from 'api';
import { useSelector } from 'react-redux';
import { checkHasAnyPermission, PERMISSION } from 'constants/permission';

const validateShare = (v = []) => {
  return v
    .filter((item) => validateEmail(item))
    .map((item) => `'${item}' invalid email format`)
    .join(',');
};

const Share = ({ dcsId, validate, pauseDisabled }) => {
  const [options, setOptions] = useState([]);
  const [search, setSearch] = useState();
  const { permissions } = useSelector((state) => state.auth);

  const onChangeSearch = (v) => {
    setSearch(v);
  };

  const onChangeOption = (v) => {
    setSearch();
    setOptions(v);
  };

  const getDetail = async () => {
    if (!dcsId) return;
    const res = await API.getShareInfo(dcsId);
    if (res.status === 200) {
      setOptions(res.data);
    }
  };

  const onUpdate = async () => {
    const err = validate.validateField('share');

    if (err) {
      return notification.error({
        message: 'Share',
        description: err,
      });
    }
    const res = await API.updateShareInfo({
      dcsId,
      emails: options,
    });

    if (res.status !== 200) {
      return notification.error({
        message: 'Share',
        description: res.message,
      });
    }

    notification.success({
      message: 'Share',
      description: 'Update success',
    });
  };

  useEffect(() => {
    getDetail();
    // eslint-disable-next-line
  }, [dcsId]);

  const permissionDisabled = !checkHasAnyPermission(permissions, [PERMISSION.SHARE_DCS]);

  return (
    <div className="share-block">
      <div className="warn-message">
        You need to save before the operation if you update the field access
        level.
      </div>
      <FieldRegister
        name="share"
        value={options}
        onChange={onChangeOption}
        searchValue={search}
        onSearch={onChangeSearch}
        validate={validateShare}
        options={uniq([search, ...options].filter(Boolean)).map((item) => ({
          label: item,
          value: item,
        }))}
        disabled={permissionDisabled || pauseDisabled}
      >
        {({
          onBlur,
          onChange,
          searchValue,
          onSearch,
          value,
          error,
          disabled,
          options,
        }) => (
          <TextField
            label="Emails"
            helperText={error}
            help={<span>Sharing with other user when project is private</span>}
          >
            <Select
              searchValue={searchValue}
              onSearch={onSearch}
              onChange={onChange}
              onBlur={onBlur}
              showSearch
              value={value}
              options={options}
              disabled={disabled}
              style={{ width: '100%' }}
              size="large"
              mode="tags"
              placeholder="Enter email"
            />
          </TextField>
        )}
      </FieldRegister>
      <div className="share-block__button">
        <Button disabled={pauseDisabled} onClick={onUpdate} type="primary">
          Save
        </Button>
      </div>
    </div>
  );
};

export default Share;
